import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Form, Badge, Container } from "react-bootstrap";
import SelectCategory from "../../components/SelectCategory";



const Preference = () => {
    return (
    <>
      <Row className="mx-0 breadcrumb_part">
          <SelectCategory/>
      </Row>
    </>
  );
};

export default Preference;